export const ua = navigator.userAgent
export const isIOS = /(iPhone|iPod|iPad|IOS);?/i.test(ua)
export const isAndroid = /Android/i.test(ua)
export const isWindowsWechat = ua.indexOf('WindowsWechat') > -1
export const isMacWechat = ua.indexOf('MacWechat') > -1
export const isWechat = /MicroMessenger/i.test(ua)
export const isWechatDevTools = /wechatdevtools/i.test(ua);
export const isBaiduApp = /swan\//.test(ua) || /^webswan-/.test(window.name)
export const isMiniProgram = /miniProgram/i.test(ua) || window.__wxjs_environment === 'miniprogram'
export const isQianFan = /QianFan/i.test(ua)
export const isMaJia = /MAGAPPX/i.test(ua)
export const isApp = /NodetechApp/i.test(ua)
export const isRK3568 = /rk3568/i.test(ua)
export const isComWx = /wxwork/i.test(ua);


export default {
  isIOS,
  isAndroid,
  isWindowsWechat,
  isMacWechat,
  isWechat,
  isBaiduApp,
  isMiniProgram,
  isQianFan,
  isMaJia,
  isApp,
  isRK3568,
  isWechatDevTools,
  isComWx,
}
